import { render } from "./mendian_emp.vue?vue&type=template&id=5c966273"
import script from "./mendian_emp.vue?vue&type=script&lang=js"
export * from "./mendian_emp.vue?vue&type=script&lang=js"

import "./mendian_emp.vue?vue&type=style&index=0&id=5c966273&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__